import React from 'react';
import styles from './Tabs.module.scss';

export type Tabs = {
  tabs: TabProps[]
};

export type TabProps = {
  label: React.ReactNode,
  content: React.ReactNode
};

export type ItemProps = {
  item: TabProps,
  index: number
};

const Item = ({item, index}: ItemProps) => {
  return (
    <>
      {index === 0
        ? (
          <input
            name="tabs"
            type="radio"
            id={`${index}`}
            defaultChecked
            className={styles.item}
          />
        )
        : (
          <input
            name="tabs"
            type="radio"
            id={`${index}`}
            className={styles.item}
          />
        )
      }
      <label
        htmlFor={`${index}`}
        className={styles.label}
      >
        {item.label}
      </label>
      <div className={styles.content}>
        {item.content}
      </div>
    </>
  )
};

const Tabs = ({tabs}: Tabs) => {

  return (
    <div className={styles.tabsContainer}>
      {tabs.map((item: TabProps, index: number) => {
        return <Item item={item} index={index} key={index}/>
      })}
    </div>
  );
};

export default Tabs;
